import Cookies from 'js-cookie'
const expireDay = 365
const pathName = ''

const TokenKey = 'passport'
const BindKey = 'isBindMobile'

export function getToken() {
  return Cookies.get(TokenKey)
  // return 'exfx7w1max5to1d9qepuqbb3qm33zsxu'
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: expireDay, path: pathName })
}

export function removeToken() {
  return Cookies.remove(TokenKey, { path: pathName })
}

const userKey = 'user'

export function getUserInfo() {
  return JSON.parse(Cookies.get(userKey) || null)
  // return {"id":"passport_428","nickName":"GR-Rui","mobile":"15001765115"}
}

export function setUserInfo(val) {
  const data = {
    id: val.id,
    nickName: val.nickName,
    mobile: val.mobile,
    avatar: val.avatar,
    hasCertificate: val.hasCertificate
  }
  return Cookies.set(userKey, JSON.stringify(data), { expires: expireDay, path: pathName })
}

export function removeUserInfo() {
  return Cookies.remove(userKey, { path: pathName })
}

const wxKey = 'wxInfo'

export function getWXInfo() {
  return JSON.parse(Cookies.get(wxKey) || null)
}

export function setWXInfo(val) {
  return Cookies.set(wxKey, JSON.stringify(val), { expires: expireDay, path: pathName })
}

export function removeWXInfo() {
  return Cookies.remove(wxKey, { path: pathName })
}

export function getBindMobile() {
  return Cookies.get(BindKey)
}

export function setBindMobile(status) {
  return Cookies.set(BindKey, status, { expires: expireDay, path: pathName })
}

export function removeBindMobile() {
  return Cookies.remove(BindKey, { path: pathName })
}
